/* eslint-disable no-unused-vars */
import OrderCancelledIcon from 'assets/ver2/icons/order-cancelled-icon.svg';
import useLang from 'hooks/useLang';
import { functionUtils } from 'utils';
import FxDisallowOrderMakePaymentPopup from '../popups/FxDisallowOrderMakePaymentPopup';

const FxDisallowOrderMakePaymentModal = ({
  isShow,
  title,
  content,
  action,
}) => {
  const { t } = useLang();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  return (
    <FxDisallowOrderMakePaymentPopup
      isOpen={isShow}
      imageSrc={OrderCancelledIcon}
      imagesStyles={{
        width: '150px',
        height: '150px',
      }}
      text={title || ''}
      content={content || ''}
      buttonLabel2={t('button_back_to_home')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default FxDisallowOrderMakePaymentModal;
